
import { useState } from "react";

import AccountInventoryTable from "../../components/account-inventory/yours/accountInventoryTable.jsx";
import { useAccInventoryYours } from "../../api/account/useAccInventoryYours";
import GetAccountStatusData from "../../components/account-inventory/yours/getAccountStatus";
import { YoursTableSkeleton,AccountInventoryPaginationSkeleton, AccountTableSearchbarSkeleton, AccountStatusSkeleton } from "../../components/account-inventory/skeleton/accountInventorySkeleton";
import Filters from "../../components/account-inventory/yours/filterComponent";
import AccountInventoryPagination from "../../components/account-inventory/yours/accountInventoryTablePagination";
import AccountTableSearchbar from "../../components/account-inventory/yours/accountInventoryTableSearchbar";

export default function YoursAccountInventoryPage() {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [filters, setFilters] = useState(null);
    const [searchName, setSearchName] = useState("");
    const [sortField, setSortField] = useState('last_transaction_datetime'); // 'last_transaction_datetime' or 'updated_time'
    const [sortOrder, setSortOrder] = useState('desc'); // 'asc' or 'desc'
    
    // Get data
    const { data, totalPages, totalAccounts, accountStatusCount, isLoading, absoluteTotal, refetch } = useAccInventoryYours(page, pageSize, selectedStatus, filters, searchName, sortField, sortOrder);
    
    const handleStatusChange = (status) => {
        setSelectedStatus(status);
        setPage(1);
    };
    const handleSearch = (name) => {
        setSearchName(name);
        setPage(1);
    };
    const churnLikelihoodOptions = [
        { id: 1, label: 'Activated' },
        { id: 2, label: 'Dormant' },
        { id: 3, label: 'Sabik' },
        { id: 4, label: 'Sirius' },
        { id: 5, label: 'Spica' },
        { id: 5, label: 'Sargas' },
    ];

    const productsOptions = [
        { id: 1, label: 'Remittance' },
        { id: 2, label: 'Insurance' },
        { id: 3, label: 'Re-KYC' },
        { id: 4, label: 'Referral' },
        { id: 5, label: 'Financing' },
    ];

    const relationshipOptions = [
        { id: 1, label: 'Cold' },
        { id: 2, label: 'Warm' },
        { id: 3, label: 'Hot' }
    ];

    const profileNameOptions = [
        { id: 1, label: 'Core Customer (Loyal)' },
        { id: 2, label: 'Farmable (Avg.)' },
        { id: 3, label: 'Growth Potential' },
        { id: 4, label: 'Need-Based (Avg.)'},
        { id: 5, label: 'Farmable (Tight)' },
        { id: 6, label: 'Farmable (Loose)' },
        { id: 7, label: 'Newbie' },
        { id: 8, label: 'Fresh Meat' },
        { id: 9, label: 'Bargain Hunter' },
        { id: 10, label: 'Need-Based (Tight)' },
        { id: 11, label: 'Need-Based (Loose)' },
        { id: 12, label: 'Core Customer (EX-GF)' },
        { id: 13, label: 'Losers' },
        { id: 14, label: 'Dormant' },
        { id: 15, label: 'Wanderer' }
    ];
    const handleFilterChange = (filters) => {
        const selectedFilters = {
            churnlikelihood: filters.churnlikelihood.map(id =>
                churnLikelihoodOptions.find(option => option.id === id)?.label
            ).filter(Boolean),
            products: filters.products.map(id => 
                productsOptions.find(option => option.id === id)?.label
            ).filter(Boolean),
            relationship: filters.relationship.map(id =>
                relationshipOptions.find(option => option.id === id)?.label
            ).filter(Boolean),
            profilename: filters.profilename.map(id =>
                profileNameOptions.find(option => option.id === id)?.label
            ).filter(Boolean)
        };
        
        setPage(1);
        setFilters(selectedFilters);
    };
    const handleRefetch = () => {
        refetch();
    };

    const handleSort = (field) => {
        if (sortField === field) {
            // Toggle sort order if same field
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            // Set new field and default to desc
            setSortField(field);
            setSortOrder('desc');
        }
        setPage(1); // Reset to first page when sorting
    };
    
    return(
        <div className="min-h-screen py-2 px-3 md:px-6">
            <div className="justify-between py-2 md:py-4">
                <Filters onFilterChange={handleFilterChange} />
            </div>
            {isLoading ? (
                <>
                    <AccountStatusSkeleton />
                    <div className="max-auto mx-auto bg-white border-t rounded-t-lg shadow-[2px_0_8px_rgba(0,0,0,0.1)]">
                        <div className="p-3 md:p-4 flex flex-col gap-3">
                            <AccountTableSearchbarSkeleton />
                        </div>
                    </div>
                    <div className="max-auto mx-auto bg-white shadow-md rounded-b-lg">
                        <AccountInventoryPaginationSkeleton/>
                        <YoursTableSkeleton/>
                    </div>
                </>
            ) : (
                <>
                    <GetAccountStatusData
                        onStatusChange={handleStatusChange}
                        selectedStatus={selectedStatus}
                        totalAccounts={totalAccounts}
                        accountStatusCount={accountStatusCount}
                    />
                    <div className="max-auto mx-auto bg-white border-t rounded-t-lg shadow-[2px_0_8px_rgba(0,0,0,0.1)]">
                        <div className="p-3 md:p-4 flex flex-col gap-3">
                            {/* Search bar - full width on mobile */}
                            <AccountTableSearchbar 
                                onSearch={handleSearch}
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                    <div className="max-auto mx-auto bg-white shadow-md rounded-b-lg ">
                        <AccountInventoryPagination
                            page={page}
                            setPage={setPage}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            totalAccounts={totalAccounts}
                            absoluteTotal={absoluteTotal}
                            totalPages={totalPages}
                        />
                        <AccountInventoryTable 
                            data={data} 
                            totalPages={totalPages} 
                            refetch={handleRefetch}
                            onSort={handleSort}
                            sortField={sortField}
                            sortOrder={sortOrder}
                        />
                    </div>
                </>
            )}
        </div>
    )
}

